/* Asama header: hover-open for the desktop mega menu and the drawer's own close button.
   Dawn's HeaderMenu / HeaderDrawer elements keep owning click, Enter/Space, Escape,
   focusout and aria-expanded; this only adds intent-delayed hover and one extra close path. */
(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
  const menus = [...document.querySelectorAll('header-menu')];
  const closeAll = (except) => menus.forEach((menu) => menu !== except && menu.close && menu.close());

  menus.forEach((menu) => {
    const details = menu.querySelector('details');
    const summary = details && details.querySelector('summary');
    if (!summary) return;
    let timer;

    const set = (open) => {
      clearTimeout(timer);
      if (details.open === open) return;
      details.open = open;
      summary.setAttribute('aria-expanded', String(open));
    };

    menu.addEventListener('pointerenter', () => {
      if (!desktop.matches || !hoverable.matches) return;
      clearTimeout(timer);
      closeAll(menu);
      timer = setTimeout(() => set(true), 60);
    });

    menu.addEventListener('pointerleave', () => {
      if (!hoverable.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => set(false), 150);
    });
  });

  // Escape also closes a hover-opened panel (Dawn only handles Escape when focus is inside it).
  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  document.querySelectorAll('header-drawer').forEach((drawer) => {
    const summary = drawer.querySelector('summary');
    drawer.querySelectorAll('[data-drawer-close]').forEach((button) => {
      button.addEventListener('click', (event) => drawer.closeMenuDrawer(event, summary));
    });
  });
})();
